/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StringResources from '../nls/StringResources';
import RecommendedCommon from '../RecommendedCommon';

import './recommended.scss';

class Recommendation extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<RecommendedCommon
				{...this.props}
				className="vis-recommended"
				title={StringResources.get('recommended_visualizations')}
				enableSeeMore={false}
				isVizTypeLocked={this.props.isVizTypeLocked}
				recommendationFilter = {this.props.recommendationFilter}
				selectedVisId={this.props.selectedVisId}
				logger={this.props.logger}
			/>
		);
	}

}

Recommendation.propTypes = {
	dashboardApi: PropTypes.object.isRequired,
	onClickItem: PropTypes.func,
	isVizTypeLocked: PropTypes.bool,
	recommendationFilter: PropTypes.string,
	selectedVisId: PropTypes.string,
	recommendationVM: PropTypes.object.isRequired,
	additionalProperties: PropTypes.arrayOf(PropTypes.object),
	logger: PropTypes.object
};
Recommendation.defaultProps = {
	onClickItem: () => {},
	additionalProperties: []
};

export default Recommendation;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/recommended/Recommended.js